<ng-container>
  <div class="bg-white" [ngClass]="srvRpDesign.getResponsiveClass('p-4', 'p-3')">

    <div class="font-dialog-mfa-title d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
      <span>{{ getDialogHeader() }}</span>
    </div>

    <div class="font-dialog-mfa-content" mat-dialog-content [ngClass]="{'px-0 pb-0' : (srvRpDesign.isMobile$ | async)}">
      <p>{{ this.getDialogNote1() }}</p>
      <p>{{ this.getDialogNote2() }}</p>

      <form [formGroup]="mfaForm">
        <mat-form-field appearance="outline" class="col-12">
          <mat-label class="me-1">{{'MFA_VERIFY.MFA_CODE' | translate}}</mat-label>
          <input matInput required formControlName="mfaCode" autocorrect="off" autocomplete="off" [maxlength]="this.maxLength" placeholder="{{'MFA_VERIFY.MFA_CODE' | translate}}" />
          <mat-error>{{ errors.mfaCode }}</mat-error>
        </mat-form-field>

        <!-- For Logon MFA Grace Period-->
        <mat-checkbox class="font-dialog-mfa-note" formControlName="trustDevice" [ngClass]="UIUtilityService.showIfTrue(isGracePeriodEnable())">
          {{ PlatformService.isMobile() ? ("MFA_VERIFY.INTERNAL_MFA_GRACE_PERIOD_NOTE_APP" | translate) : ("MFA_VERIFY.INTERNAL_MFA_GRACE_PERIOD_NOTE_WEB" | translate) }}
          {{ "MFA_VERIFY.INTERNAL_MFA_GRACE_PERIOD_NOTE_1" | translate}} {{ this.externalSettings.systemVariables.tfaGracePeriod }}
          {{ "MFA_VERIFY.INTERNAL_MFA_GRACE_PERIOD_NOTE_2" | translate}} 
          {{ PlatformService.isMobile() ? ("MFA_VERIFY.INTERNAL_MFA_GRACE_PERIOD_NOTE_3_APP" | translate) : ("MFA_VERIFY.INTERNAL_MFA_GRACE_PERIOD_NOTE_3_WEB" | translate) }}
        </mat-checkbox>
      </form>

    </div>

    <div class="my-1 p-0" mat-dialog-actions [ngClass]="srvRpDesign.getDialogButtonsPadClass()">

      <button class="py-4 font-button button-action-cancel" mat-button (click)="onCancel($event)">{{ 'BUTTON_BACK' | translate }}</button>

      <button class="py-4 font-button button-action-base" mat-button [disabled]="isProcessing" (debounceClick)="onConfirm($event)" cdkFocusInitial appDebounceClick>
        {{ 'BUTTON_CONFIRM' | translate }}
      </button>

    </div>
  </div>
</ng-container>